import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    columnGap: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
  },
  text: {
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
